const KEY = 'ops:favourites:v1'
export class Favourites {
  keys = $state<string[]>([])
  constructor() {
    try {
      const value: unknown = JSON.parse(localStorage.getItem(KEY) ?? '[]')
      if (Array.isArray(value))
        this.keys = [
          ...new Set(
            value.filter((x): x is string => typeof x === 'string' && /^(lift|run):\d+$/.test(x)),
          ),
        ].slice(0, 300)
    } catch {
      /* A blocked store still allows favourites for this visit. */
    }
  }
  has(key: string) {
    return this.keys.includes(key)
  }
  toggle(key: string) {
    this.keys = this.has(key) ? this.keys.filter((x) => x !== key) : [...this.keys, key]
    try {
      localStorage.setItem(KEY, JSON.stringify(this.keys))
    } catch {
      /* Keep this visit's choices. */
    }
  }
}
